import { Component, Input } from '@angular/core';

@Component({
    selector: 'schema-connector',
    template: require('./schema-connector.component.html'),
    styles: [require('./schema-connector.component.scss')]
})

export class SchemaConnectorComponent {

    @Input() public showConnector: boolean = false;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/schema-connector/schema-connector.component.ts